import { Outlet } from 'react-router-dom'

const LifeBridgeTeam = () => {
  return <Outlet />
}

export default LifeBridgeTeam
